
import { defineComponent } from 'vue';

export default defineComponent({
	props: { isdark: { type: Boolean, required: false, default: false } },
});
